<template>
  <div class="software-examples">
    <h2 class="h5 tac slide-up">Ukázky řídicího systému</h2>
    <div class="software-examples__grid">
      <div v-for="(image, index) in images" :key="index" class="software-examples__item slide-up">
        <div class="software-examples__image" @click="showLightbox(index)">
          <img :src="image.url" :alt="image.alt">
        </div>
      </div>
    </div>
    
    <teleport to="body">
      <vue-easy-lightbox
        :visible="visible"
        :imgs="lightboxImages"
        :index="currentIndex"
        @hide="handleHide"
      ></vue-easy-lightbox>
    </teleport>
  </div>
</template>

<script>
import VueEasyLightbox from 'vue-easy-lightbox'

export default {
  name: 'SoftwareExamples',
  
  components: {
    VueEasyLightbox
  },
  
  data() {
    return {
      currentIndex: 0,
      visible: false,
      images: [
        { 
          url: '/dist/img/software/ukazka01.png', 
          alt: 'Ukázka řídicího systému 1' 
        },
        { 
          url: '/dist/img/software/ukazka02.png', 
          alt: 'Ukázka řídicího systému 2' 
        },
        { 
          url: '/dist/img/software/ukazka03.png', 
          alt: 'Ukázka řídicího systému 3' 
        },
        { 
          url: '/dist/img/software/ukazka04.png', 
          alt: 'Ukázka řídicího systému 4' 
        }
      ]
    }
  },
  
  computed: {
    lightboxImages() {
      return this.images.map(img => img.url)
    }
  },
  
  methods: {
    showLightbox(index) {
      this.currentIndex = index
      this.visible = true
    },
    
    handleHide() {
      this.visible = false
    }
  }
}
</script> 